import axios from '../axios'
import qs from 'qs';
import { getToken } from '@/utils/auth';

//查询足迹记录日志
export const query = (data)=>{
	data.token = getToken();
	data = qs.stringify(data);
	return axios({
		url:'/record/fp.record.query.php',
		method:'post',
		data
	})
}

//记录足迹
export const record = (data)=>{
	data.token = getToken();
	data = qs.stringify(data);
	return axios({
		url:'/record/fp.record.php',
		method:'post',
		data
	})
}

// ArcGis逆地理解析 2025-10-07废弃
// export const getArcGisReverseGeocode = (lng,lat)=>{
// 	let data = {
// 		location:`${lng},${lat}`,
// 		langCode:'EN',
// 		outSR:'',
// 		forStorage:'false',
// 		f:'json',
// 	};
// 	return axios({
// 		url:'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode',
// 		method:'get',
// 		params:data
// 	})
// }

// 天地图逆地理解析
export const getTDTGisReverseGeocode = (lng,lat)=>{
	let data = {
		postStr:`{'lon':${lng},'lat':${lat},'ver':1}`,
		type:'geocode',
		tk:'57c0ec1e6aa0d495b782481ad9ba6084',
	};
	return axios({
		url:'http://api.tianditu.gov.cn/geocoder',
		noAxiosTips:true,
		method:'get',
		params:data
	})
}


// WEBPACK FOOTER //
// ./src/provider/api/record.js